import { render, staticRenderFns } from "./BoutonCommande.vue?vue&type=template&id=498f7a94"
import script from "./BoutonCommande.vue?vue&type=script&lang=ts"
export * from "./BoutonCommande.vue?vue&type=script&lang=ts"
import style0 from "./BoutonCommande.vue?vue&type=style&index=0&id=498f7a94&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports